<script setup>
import { computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const router = useRouter();
const route = useRoute();
const auth = useAuthStore();

const roleLabel = computed(() => {
  const roleMap = {
    admin: "Admin",
    finance: "Finance",
    user: "User",
  };
  return roleMap[auth.user?.role] || auth.user?.role || "-";
});

const PAGE_META = {
  dashboard: {
    title: "Dashboard",
    subtitle: "ภาพรวมสถานะการจัดเก็บค่าส่วนกลาง",
  },
  units: {
    title: "รายการยูนิต / บ้าน / ห้อง",
    subtitle: "จัดการข้อมูลยูนิตและสถานะการชำระ",
  },
  "unit-detail": {
    title: "รายละเอียดยูนิต",
    subtitle: "ข้อมูลยูนิต ลูกบ้าน และประวัติการชำระ",
  },
  residents: {
    title: "รายการลูกบ้าน",
    subtitle: "จัดการข้อมูลเจ้าของและผู้เช่า",
  },
  "resident-detail": {
    title: "รายละเอียดลูกบ้าน",
    subtitle: "ข้อมูลลูกบ้าน ติดต่อ และประวัติการชำระ",
  },
  invoices: {
    title: "รายการใบแจ้งหนี้",
    subtitle: "จัดการการออกบิลและติดตามสถานะ",
  },
  "invoice-detail": {
    title: "รายละเอียดใบแจ้งหนี้",
    subtitle: "ข้อมูลบิล รายการเรียกเก็บ และประวัติชำระ",
  },
  payments: {
    title: "รายการรับชำระเงิน",
    subtitle: "จัดการการรับชำระและตรวจสอบสถานะ",
  },
  "payment-detail": {
    title: "รายละเอียดการรับชำระ",
    subtitle: "ข้อมูลรายการรับชำระและลำดับเหตุการณ์",
  },
  "payment-create": {
    title: "ฟอร์มรับชำระเงิน",
    subtitle: "บันทึกรายการรับชำระค่าส่วนกลาง",
  },
  arrears: {
    title: "รายการค้างชำระ",
    subtitle: "ติดตามยอดค้างชำระและวางแผนการติดตาม",
  },
  reports: {
    title: "รายงานภาพรวม",
    subtitle: "สรุปรายรับ สถานะลูกหนี้ และ Insight",
  },
};

const pageTitle = computed(() => PAGE_META[route.name]?.title ?? "Central Fee");
const pageSubtitle = computed(() => PAGE_META[route.name]?.subtitle ?? "");

const handleLogout = () => {
  auth.logout();
  router.push("/login");
};
</script>
<template>
  <div class="topbar bg-white border-bottom px-4 py-2">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-none d-md-block">
        <h4 class="mb-1 fw-bold">{{ pageTitle }}</h4>
        <!-- <div class="text-muted small">{{ pageSubtitle }}</div> -->
      </div>

      <div class="d-flex align-items-center gap-3">
        <div class="text-end">
          <div class="fw-semibold">{{ auth.user?.name }}</div>
          <div class="small text-muted fw-semibold">{{ roleLabel }}</div>
        </div>

        <button
          class="btn btn-outline-danger rounded-3 btn-md"
          @click="handleLogout"
        >
          <i class="bi bi-box-arrow-right me-1"></i>ออกจากระบบ
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.topbar {
  position: sticky;
  top: 0;
  z-index: 10;
}
@media (max-width: 991.98px) {
  .brand-full {
    display: none;
  }
}
</style>
